import React, {useState} from "react";
import Button from '@mui/material/Button';
import SummarizeIcon from '@mui/icons-material/Summarize';
import CustomDialog from "../../../../../components/Dialog/DiaComp";
import { Brain_Variants_TableData } from "./Get_Brain_variants_table";


export default function Dia_Brain_Variants() {

    const [open, setOpen] = useState(false);
    const handleOpen = () => {setOpen(true);};
    const handleClose = () => {setOpen(false);};


return(
<>      
    <Button onClick={handleOpen} variant="text" sx={{ }}>
            <SummarizeIcon sx={{fontSize: '300%', color: 'tertiary.light', '&:hover': { color: 'primary.light'}, }} />
    </Button>

    <CustomDialog open={open} onClose={handleClose}

        title='Variants associated with brain cancer'

        content={ <Brain_Variants_TableData />}

/>

</>
)}